<div class="calc-wrapper">

  <!-- Форма ввода «Целевые показатели ракета-носителя» -->
   
  <form novalidate>
    <section class="card">
      <header class="card-header">
        <h2>Целевые показатели ракета-носителя</h2>
      </header>
      <div class="card-body">

        <!-- Стартовая масса -->
        <div class="form-row">
          <label for="start-mass-min">
            Стартовая масса ракета-носителя с полезной нагрузкой, кг <span class="required">*</span>
          </label>
          <div class="range">
            <span class="prefix">от</span>
            <input id="start-mass-min" type="number" name="Start_mass_min"
                   placeholder="{{def.Start_mass_min}}"
                   (focus)="fillIfEmpty('Start_mass_min',$event)"
                   [(ngModel)]="model.Start_mass_min" required>
            <span class="prefix">до</span>
            <input id="start-mass-max" type="number" name="Start_mass_max"
                   placeholder="{{def.Start_mass_max}}"
                   (focus)="fillIfEmpty('Start_mass_max',$event)"
                   [(ngModel)]="model.Start_mass_max" required>
          </div>
        </div>

        <!-- Масса полезной нагрузки -->
        <div class="form-row">
          <label for="mass-pn-min">
            Масса полезной нагрузки, кг <span class="required">*</span>
          </label>
          <div class="range">
            <span class="prefix">от</span>
            <input id="mass-pn-min" type="number" name="Mass_pn_min"
                   placeholder="{{def.Mass_pn_min}}"
                   (focus)="fillIfEmpty('Mass_pn_min',$event)"
                   [(ngModel)]="model.Mass_pn_min" required>
            <span class="prefix">до</span>
            <input id="mass-pn-max" type="number" name="Mass_pn_max"
                   placeholder="{{def.Mass_pn_max}}"
                   (focus)="fillIfEmpty('Mass_pn_max',$event)"
                   [(ngModel)]="model.Mass_pn_max" required>
          </div>
        </div>

        <!-- Объём полезной нагрузки -->
        <div class="form-row">
          <label for="volume-pn-min">
            Объём полезной нагрузки, м<sup>3</sup> <span class="required">*</span>
          </label>
          <div class="range">
            <span class="prefix">от</span>
            <input id="volume-pn-min" type="number" name="Volume_pn_min"
                   placeholder="{{def.Volume_pn_min}}"
                   (focus)="fillIfEmpty('Volume_pn_min',$event)"
                   [(ngModel)]="model.Volume_pn_min" required>
            <span class="prefix">до</span>
            <input id="volume-pn-max" type="number" name="Volume_pn_max"
                   placeholder="{{def.Volume_pn_max}}"
                   (focus)="fillIfEmpty('Volume_pn_max',$event)"
                   [(ngModel)]="model.Volume_pn_max" required>
          </div>
        </div>

        <!-- Высота выводимого груза -->
        <div class="form-row">
          <label for="height-output-min">
            Высота выводимого груза, м <span class="required">*</span>
          </label>
          <div class="range">
            <span class="prefix">от</span>
            <input id="height-output-min" type="number" name="Height_output_min"
                   placeholder="{{def.Height_output_min}}"
                   (focus)="fillIfEmpty('Height_output_min',$event)"
                   [(ngModel)]="model.Height_output_min" required>
            <span class="prefix">до</span>
            <input id="height-output-max" type="number" name="Height_output_max"
                   placeholder="{{def.Height_output_max}}"
                   (focus)="fillIfEmpty('Height_output_max',$event)"
                   [(ngModel)]="model.Height_output_max" required>
          </div>
        </div>

        <!-- Количество ступеней -->
        <div class="form-row">
          <label for="stages-number">
            Количество ступеней <span class="required">*</span>
          </label>
          <input id="stages-number" type="number" name="Stages_number"
                 placeholder="{{def.Stages_number}}"
                 [(ngModel)]="model.Stages_number"
                 (ngModelChange)="onStagesNumberChange($event)"
                 min="1" required>
        </div>

        <!-- Перегрузки -->
        <div class="form-row">
          <label for="start-overload-min">
            Начальное значение перегрузки, g <span class="required">*</span>
          </label>
          <div class="range">
            <span class="prefix">от</span>
            <input id="start-overload-min" type="number" name="Start_overload_min"
                   placeholder="{{def.Start_overload_min}}"
                   (focus)="fillIfEmpty('Start_overload_min',$event)"
                   [(ngModel)]="model.Start_overload_min" required>
            <span class="prefix">до</span>
            <input id="start-overload-max" type="number" name="Start_overload_max"
                   placeholder="{{def.Start_overload_max}}"
                   (focus)="fillIfEmpty('Start_overload_max',$event)"
                   [(ngModel)]="model.Start_overload_max" required>
          </div>
        </div>

        <div class="form-row">
          <label for="finish-overload-min">
            Максимальное значение перегрузки, g <span class="required">*</span>
          </label>
          <div class="range">
            <span class="prefix">от</span>
            <input id="finish-overload-min" type="number" name="Finish_overload_min"
                   placeholder="{{def.Finish_overload_min}}"
                   (focus)="fillIfEmpty('Finish_overload_min',$event)"
                   [(ngModel)]="model.Finish_overload_min" required>
            <span class="prefix">до</span>
            <input id="finish-overload-max" type="number" name="Finish_overload_max"
                   placeholder="{{def.Finish_overload_max}}"
                   (focus)="fillIfEmpty('Finish_overload_max',$event)"
                   [(ngModel)]="model.Finish_overload_max" required>
          </div>
        </div>

        <!-- Герметичность -->
        <div class="form-row checkbox-row">
          <label>
            <input type="checkbox" [(ngModel)]="model.Tightness" name="Tightness">
            Герметичность
          </label>
        </div>

        <!-- Дополнительные поля -->
        <div class="extra" *ngIf="showExtraFields">
          <hr>
          <div class="form-row">
            <label for="volume-rocket-min">Объём ракета-носителя, м<sup>3</sup></label>
            <div class="range">
              <span class="prefix">от</span>
              <input id="volume-rocket-min" type="number" name="Volume_rocket_min"
                     placeholder="{{def.Volume_rocket_min}}"
                     (focus)="fillIfEmpty('Volume_rocket_min',$event)"
                     [(ngModel)]="model.Volume_rocket_min">
              <span class="prefix">до</span>
              <input id="volume-rocket-max" type="number" name="Volume_rocket_max"
                     placeholder="{{def.Volume_rocket_max}}"
                     (focus)="fillIfEmpty('Volume_rocket_max',$event)"
                     [(ngModel)]="model.Volume_rocket_max">
            </div>
          </div>
          <div class="form-row">
            <label for="length-rocket-min">Длина ракета-носителя, м</label>
            <div class="range">
              <span class="prefix">от</span>
              <input id="length-rocket-min" type="number" name="Length_rocket_min"
                     placeholder="{{def.Length_rocket_min}}"
                     (focus)="fillIfEmpty('Length_rocket_min',$event)"
                     [(ngModel)]="model.Length_rocket_min">
              <span class="prefix">до</span>
              <input id="length-rocket-max" type="number" name="Length_rocket_max"
                     placeholder="{{def.Length_rocket_max}}"
                     (focus)="fillIfEmpty('Length_rocket_max',$event)"
                     [(ngModel)]="model.Length_rocket_max">
            </div>
          </div>
          <div class="form-row">
            <label for="diameter-rocket-min">Диаметр ракета-носителя, м</label>
            <div class="range">
              <span class="prefix">от</span>
              <input id="diameter-rocket-min" type="number" name="Diameter_rocket_min"
                     placeholder="{{def.Diameter_rocket_min}}"
                     (focus)="fillIfEmpty('Diameter_rocket_min',$event)"
                     [(ngModel)]="model.Diameter_rocket_min">
              <span class="prefix">до</span>
              <input id="diameter-rocket-max" type="number" name="Diameter_rocket_max"
                     placeholder="{{def.Diameter_rocket_max}}"
                     (focus)="fillIfEmpty('Diameter_rocket_max',$event)"
                     [(ngModel)]="model.Diameter_rocket_max">
            </div>
          </div>
        </div>

      </div>
      <footer class="card-footer">
        <button type="button" class="toggle-btn" (click)="toggleExtra()">
          {{ showExtraFields ? 'Скрыть доп. поля' : 'Показать доп. поля' }}
        </button>
      </footer>
    </section>

    <div class="form-actions">
      <button type="button" class="btn-save" (click)="onSubmit()">Рассчитать</button>
      <button type="button" class="btn-cancel" (click)="onCancel()">Отмена</button>
    </div>
  </form>


  <!-- Раздел «Требования к элементам ракета-носителя» -->
  <section class="requirements" *ngIf="showRequirements" @fadeInOut>
    <div class="results-container">

      <!-- Переключатель режимов -->
      <div class="toggle-group" *ngIf="(model.Stages_number ?? 0) > 1">
        <button type="button"
                [class.active]="stagesMode === 'single'"
                (click)="stagesMode = 'single'">
          Одноступенчатый
        </button>
        <button type="button"
                [class.active]="stagesMode === 'multi'"
                (click)="stagesMode = 'multi'">
          Многоступенчатый
        </button>
      </div>

      <!-- Карточки результатов -->
      <div class="cards-wrapper">

        <!-- Single -->
        <ng-container *ngIf="stagesMode === 'single'">
          <div class="card stage-card">
            <header><h3>Двигательная установка</h3></header>
            <div class="card-body">

              <!-- Двигатель -->
              <div class="requirement-block">
                <h4>Двигатель</h4>
                <div class="range-row" *ngFor="let f of engineFields">
                  <label>{{ f.label }}</label>
                  <div class="range-inputs">
                    <input [value]="computed[f.key + 'Min']" readonly>
                    <span>до</span>
                    <input [value]="computed[f.key + 'Max']" readonly>
                  </div>
                </div>
                <button class="btn-variants">Существующие варианты</button>
              </div>

              <!-- Корпусные детали -->
              <div class="grid-2">
                <ng-container *ngFor="let part of bodyParts">
                  <div class="part-block">
                    <h5>{{ part.title }}</h5>
                    <div class="range-row" *ngFor="let f of part.fields">
                      <label>{{ f.label }}</label>
                      <div class="range-inputs">
                        <input [value]="computed[f.minKey]" readonly>
                        <span>до</span>
                        <input [value]="computed[f.maxKey]" readonly>
                      </div>
                    </div>
                    <button class="btn-variants">Существующие варианты</button>
                  </div>
                </ng-container>
              </div>

              <!-- Топливный отсек, Топливо, Окислитель -->
              <div class="grid-3">

                <div class="requirement-block">
                  <h4>Топливный отсек</h4>
                  <div class="range-row" *ngFor="let f of fuelTankFields">
                    <label>{{ f.label }}</label>
                    <div class="range-inputs">
                      <input [value]="computed[f.minKey]" readonly><span>до</span>
                      <input [value]="computed[f.maxKey]" readonly>
                    </div>
                  </div>
                  <button class="btn-variants">Существующие варианты</button>
                </div>

                <div class="requirement-block">
                  <h4>Топливо</h4>
                  <div class="range-row" *ngFor="let f of propellantFields">
                    <label>{{ f.label }}</label>
                    <div class="range-inputs">
                      <input [value]="computed[f.minKey]" readonly><span>до</span>
                      <input [value]="computed[f.maxKey]" readonly>
                    </div>
                  </div>
                  <button class="btn-variants">Существующие варианты</button>
                </div>

                <div class="requirement-block">
                  <h4>Окислитель</h4>
                  <div class="range-row" *ngFor="let f of oxidizerFields">
                    <label>{{ f.label }}</label>
                    <div class="range-inputs">
                      <input [value]="computed[f.minKey]" readonly><span>до</span>
                      <input [value]="computed[f.maxKey]" readonly>
                    </div>
                  </div>
                  <button class="btn-variants">Существующие варианты</button>
                </div>

              </div>

            </div>
            <footer class="card-footer">
              <button class="btn-calc" (click)="onRecalculate()">Пересчитать</button>
              <button class="btn-cancel" (click)="onBack()">Назад</button>
            </footer>
          </div>
        </ng-container>

        <!-- Multi -->
        <ng-container *ngIf="stagesMode === 'multi'">
          <ng-container *ngFor="let _ of stagesArray; let i = index">
            <div class="card stage-card">
              <header><h3>Ступень {{ i + 1 }}</h3></header>
              <div class="card-body">

                <div class="requirement-block">
                  <h4>Двигатель</h4>
                  <div class="range-row" *ngFor="let f of engineFields">
                    <label>{{ f.label }}</label>
                    <div class="range-inputs">
                      <input [value]="computedStages[i][f.key + 'Min']" readonly>
                      <span>до</span>
                      <input [value]="computedStages[i][f.key + 'Max']" readonly>
                    </div>
                  </div>
                </div>

                <div class="grid-2">
                  <ng-container *ngFor="let part of bodyParts">
                    <div class="part-block">
                      <h6>{{ part.title }}</h6>
                      <div class="range-row" *ngFor="let f of part.fields">
                        <label>{{ f.label }}</label>
                        <div class="range-inputs">
                          <input [value]="computedStages[i][f.minKey]" readonly>
                          <span>до</span>
                          <input [value]="computedStages[i][f.maxKey]" readonly>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <div class="grid-3">

                  <div class="requirement-block">
                    <h4>Топливный отсек</h4>
                    <div class="range-row" *ngFor="let f of fuelTankFields">
                      <label>{{ f.label }}</label>
                      <div class="range-inputs">
                        <input [value]="computedStages[i][f.minKey]" readonly><span>до</span>
                        <input [value]="computedStages[i][f.maxKey]" readonly>
                      </div>
                    </div>
                  </div>

                  <div class="requirement-block">
                    <h4>Топливо</h4>
                    <div class="range-row" *ngFor="let f of propellantFields">
                      <label>{{ f.label }}</label>
                      <div class="range-inputs">
                        <input [value]="computedStages[i][f.minKey]" readonly><span>до</span>
                        <input [value]="computedStages[i][f.maxKey]" readonly>
                      </div>
                    </div>
                  </div>

                  <div class="requirement-block">
                    <h4>Окислитель</h4>
                    <div class="range-row" *ngFor="let f of oxidizerFields">
                      <label>{{ f.label }}</label>
                      <div class="range-inputs">
                        <input [value]="computedStages[i][f.minKey]" readonly><span>до</span>
                        <input [value]="computedStages[i][f.maxKey]" readonly>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </ng-container>
        </ng-container>

      </div>

      <!-- Сохранение/Отчёт -->
      <div class="form-actions-bottom">
        <button class="btn-save" (click)="onSave()">Сохранить</button>
        <button class="btn-save" (click)="onSaveAs()">Сохранить как</button>
        <button class="btn-save" (click)="onGenerateReport()">Отчёт</button>
      </div>

    </div>
  </section>

</div>
